export default "__VITE_ASSET__C260HAkX__"